@if (showHeader()) {
  <div class="dlg-head">
    <!-- &ngsp; is the one space Angular's whitespace collapsing will not eat,
         so the accent word never fuses onto the title. -->
    <h3 [id]="titleId()">{{ dref().title() }}@if (cfg().titleAccent) {&ngsp;<em>{{ cfg().titleAccent }}</em>}</h3>
    @if (cfg().showHeaderClose !== false) {
      <button
        type="button"
        class="btn btn-ghost btn-sm dlg-x"
        aria-label="Close dialog"
        [disabled]="dref().busy()"
        (click)="onHeaderClose()"
      >&times;</button>
    }
  </div>
  @if (cfg().subtitle) {
    <p class="note dlg-sub">{{ cfg().subtitle }}</p>
  }
}

<div class="dlg-body">
  <ng-container #content />
</div>

@if (showFooter()) {
  <div class="dlg-foot" [style.justify-content]="footerJustify()">
    @if (cfg().footerTemplate; as footer) {
      <ng-container [ngTemplateOutlet]="footer" [ngTemplateOutletContext]="{ ref: dref() }" />
    } @else {
      @if (cfg().showReset === true) {
        <button
          type="button"
          class="btn btn-ghost dlg-reset"
          [disabled]="dref().busy()"
          (click)="onReset()"
        >{{ cfg().resetLabel ?? 'Reset' }}</button>
      }
      @if (cfg().showCancel !== false) {
        <button
          type="button"
          class="btn btn-ghost dlg-cancel"
          [disabled]="dref().busy()"
          (click)="onCancel()"
        >{{ cfg().cancelLabel ?? 'Cancel' }}</button>
      }
      @if (cfg().showApply === true) {
        <button
          type="button"
          class="btn btn-outline-gold dlg-apply"
          [disabled]="applyDisabled()"
          (click)="onApply()"
        >{{ cfg().applyLabel ?? 'Apply' }}</button>
      }
      @if (cfg().showSave !== false) {
        <button
          type="button"
          class="btn btn-gold dlg-save"
          [disabled]="saveDisabled()"
          (click)="onSave()"
        >{{ cfg().saveLabel ?? 'Save' }}</button>
      }
    }
  </div>
}
